import {BsPersonSquare} from 'react-icons/bs'

export const teamInfo =  [
    {icon: BsPersonSquare, title: "Peng", body: ""},
    {icon: BsPersonSquare, title: "XZ", body: ""},
    ];

